const COMMENTS = [
  {
    id: 1,
    avatar: 'R',
    name: '追剧小达人',
    time: '2小时前',
    content: '玫瑰视频真心不错！之前看香蕉视频和糖豆视频总是卡，这里高清不缓冲，一口气追完了一整部电视剧，太爽了！',
    likes: 326,
    tag: '高清体验',
  },
  {
    id: 2,
    avatar: 'M',
    name: '午夜电影控',
    time: '5小时前',
    content: '小蓝视频和蓝莓视频的热门资源这里全都有，更新速度比官方还快，每天都有新剧上线，追剧党的福音啊！',
    likes: 218,
    tag: '更新迅速',
  },
  {
    id: 3,
    avatar: 'L',
    name: '剧荒拯救者',
    time: '1天前',
    content: '之前在各种平台东找西找，现在玫瑰视频一个站就搞定了香蕉视频和糖豆视频的所有内容，索引清晰找片超方便。',
    likes: 187,
    tag: '一站聚合',
  },
  {
    id: 4,
    avatar: 'C',
    name: '周末宅家族',
    time: '1天前',
    content: '周末在家连刷了八集新剧，全程高清无卡顿，香蕉视频和小蓝视频的资源切换也很快，已经推荐给同事了！',
    likes: 153,
    tag: '流畅体验',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-3">
            真实反馈
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">观众热评</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            来自玫瑰视频用户的真实追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex flex-col hover:border-background-300/80 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 font-bold text-sm">{comment.avatar}</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-950 truncate">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                  {comment.tag}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-heart-line text-sm"></i>
                  {comment.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}